import { render } from "./PayPalPage.vue?vue&type=template&id=e55f2ef0&scoped=true"
import script from "./PayPalPage.vue?vue&type=script&lang=js"
export * from "./PayPalPage.vue?vue&type=script&lang=js"

import "./PayPalPage.vue?vue&type=style&index=0&id=e55f2ef0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e55f2ef0"]])

export default __exports__